import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import {Shared} from "../../../../shared/shared";

@Component({
  selector: 'dropdown-component' ,
  templateUrl: 'dropdownComponent.html',
  styleUrls: ['dropdownComponent.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DropdownComponent implements ViewCell, OnInit, OnChanges {
  @Input() value: any;
  @Output() changeDropdown:  EventEmitter<{row: any, id: number}> = new EventEmitter();
  rowData: any;
  options: any[];
  val: number;
  valString: string;
  showInput = false;

  showBlankSpace = false;
  @ViewChild('select') select: ElementRef;

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    this.sync();
  }

  // El componente se reutiliza cuando el padre cambia el valor o la lista de
  // opciones (por ejemplo al cambiar el curso de una asociacion, que cambia la
  // lista de tipos de curso). Sin esto seguiria mostrando el valor anterior.
  ngOnChanges() {
    this.sync();
  }

  private sync(){
    let cell = this.value != null ? this.value.cell : null;
    let options = (this.value != null && this.value.options != null) ? this.value.options : [];

    // El padre construye {cell, options} en cada ciclo de deteccion de cambios,
    // asi que solo re-sincronizamos si el contenido real ha cambiado.
    if(options === this.options && cell === this.val){
      return;
    }

    this.options = options;
    this.val = cell;
    this.showBlankSpace = cell == null || cell.length == 0;

    let obj:any = this.options.find(x => x.id == this.val);
    this.valString = obj != null ? obj.name : "";
  }

  append(){
    this.renderer.appendChild(document.body, this.select.nativeElement);
  }

  change(){
    this.showInput = false;

    //this.rowData = this.options.find(x=>x.id == this.val);

    let obj:any = this.options != null ? this.options.find(x=>x.id == this.val) : null;
    this.valString = obj != null ? obj.name : "";
    this.showBlankSpace = this.val == null;
    this.changeDropdown.emit({row: this.rowData, id: this.val});
  }
}
